export { default as Home } from "./Home";
export { default as Tech } from "./Tech";
export { default as NotFound } from "./NotFound";
